if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
Shopify.money_format = '${{amount}}';
Shopify.formatMoney=function(t,e){function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)}
// Frequently Bought Together

$('.f_product_box').each(function(){
  var self = $(this);
  $(this).find('.product_varinat select').on('change', function() {
    var mainPrice = $('option:selected', this).attr('data-price');
    var wasPrice = $('option:selected', this).attr('data-compare-price'),
        wasPrice = (wasPrice != 0) ? Shopify.formatMoney(wasPrice,Shopify.money_format) : '';
    
    $(this).parents('.product_info').find('.product_price .price').text(Shopify.formatMoney(mainPrice,Shopify.money_format)).next().text(wasPrice);
    totalPrice();
  });
  self.on('click',function(){
  	totalPrice();
  });
});

function totalPrice(){
  var tPrice = 0;
  var tcomparePrice = 0;
  var comaprecheck = false;
 
  $('.f_product_box').each(function(){
    if($(this).find('input.f_upsell_product').is(':checked')){
      var finddroporin = $(this).find('.product_varinat');
      if($(this).find('.product_varinat select').length != 0){
        tPrice += $(this).find('.product_varinat select option:selected').data('price');
        var compareval = $(this).find('.product_varinat select option:selected').data('compare-price');
        tcomparePrice += compareval;
        if(compareval==0){
          comaprecheck = true;
        }
      }else{
        tPrice += $(this).find('.product_varinat input').data('price');
        tcomparePrice += $(this).find('.product_varinat input').data('compare-price');
      }
    }       
  });
  if(comaprecheck==true){
    $('.total_was_price').hide();
  }else{
    $('.total_was_price').show();
  }
  $('.f_upsell_total_price .total_price').text(Shopify.formatMoney(tPrice,Shopify.money_format)).next().text(Shopify.formatMoney(tcomparePrice,Shopify.money_format));
}

$('.f_upsell_atc_btn .f_atc_btn').click(function(){
  var productData = { 'items': [] };
  $('.f_product_box').each(function(){
    if($(this).find('input.f_upsell_product').is(':checked')){
      var getId = '';
      if($(this).find('.product_varinat select').length != 0){
        getId = $(this).find('.product_varinat select option:selected').val();
      }else{
        getId = $(this).find('.product_varinat input').val();
      }
      productData.items.push({
        id: getId,
        qty: 1
      });
    }
  });
  if(productData.items.length){
    fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(productData)}).then(response => {
    }).catch((error) => {
     
    });
  }
});

if($('.gallery__thumbnail') != undefined){
  // Product Thumbnail Triggr Click
  // setTimeout(function(){$('.gallery__thumbnail:first-child').click()},500); 
}


$(document).ready(function(){

// Footer accordian js
  $('.footer__title').click(function(){
    $(this).toggleClass('active').next().slideToggle();
  });
  
  // Product info tab js
  
  $(".product-tab-nav-item").click(function(){
    $tabName = $(this).data("tab");
    $getTab = $(".product-tab-content-inner").hasClass($tabName);
    $getClass = $(".product-tab-content-inner"+"."+$tabName)

    if($getTab){
      $tabName = $(this).data("tab");
      $(".product-tab-nav-item").removeClass("active");
      $(this).addClass("active");
      $(".product-tab-content-inner.active").removeClass("active")
      $($getClass).addClass("active");
    }
  });



//  $('.slider--product').slick({
//    slidesToShow: 1,
//    slidesToScroll: 1,
//    infinite: false,
//    arrows: false,
//    asNavFor: '.gallery__thumbnails',
//    prevArrow: '<button type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path fill="#0379a3" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
//    nextArrow: '<button type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path fill="#0379a3" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
//    responsive: [
//      {
//        breakpoint: 768,
//        settings: {
//          dots: true
//        }
//      }
//    ]
//  });
//  $('.gallery__thumbnails').slick({
//    slidesToShow: 5,
//    slidesToScroll: 1,
//    asNavFor: '.slider--product',
//    infinite: false,
//    arrows: true,
//    focusOnSelect: true,
//    prevArrow: '<button type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path fill="#0379a3" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
//    nextArrow: '<button type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path fill="#0379a3" d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
//  });
  
})





function changeSlide(){
  if($('.slider').data("autoplay")){
    $('.slider .slider__button--next').trigger('click');
    setTimeout(changeSlide,4000);
  }
}
setTimeout(changeSlide,4000);

if ($(window).width() > 990) {
  console.log('sdmklfk');
  if ($('.product-pdp-template .shopify-product-form').find('.product__swatches').length != 0 ) {
    $('.product-pdp-template .product__row').css('padding-bottom','0px');
    $('.product-pdp-template #rc_radio_options .rc_block.rc_block__type').change(function(){
      if($(this).hasClass('rc_block__type__autodeliver')){
        $('.product-pdp-template .product__row').css('padding-bottom','228px');
      }else{
        $('.product-pdp-template .product__row').css('padding-bottom','200px');
      }
    })
  } else{
    $('.product-pdp-template .product__row').css('padding-bottom','120px');
    $('.product-pdp-template #rc_radio_options .rc_block.rc_block__type').change(function(){
      if($(this).hasClass('rc_block__type__autodeliver')){
        $('.product-pdp-template .product__row').css('padding-bottom','178px');
      }else{
        $('.product-pdp-template .product__row').css('padding-bottom','120px');
      }
    })
  }
}

// Sticky ATC Trigger
if(document.getElementById('stckbtn')){
  var secondButton = document.getElementById('stckbtn');
  secondButton.addEventListener('click', function() {
    var firstButton = document.querySelector('.button--addToCart');
    firstButton.click();
  });
}
